import { createSlice } from '@reduxjs/toolkit';

const queueSlice = createSlice({
  name: 'queue',
  initialState: [],
  reducers: {
    addToQueue: (state, action) => {
      state.push({
        ...action.payload,
        isStarted: false,
        step: 'queued',
        progress: 0,
      });
    },
    markAsStarted: (state, action) => {
      const item = state.find((i) => i.queryID === action.payload.queryID);
      if (item) {
        item.isStarted = true;
        item.step = 'findingExperts';
        item.progress = 0;
      }
    },
    updateProgress: (state, action) => {
      const { queryID, step, progress } = action.payload;
      const item = state.find((i) => i.queryID === queryID);
      if (item) {
        item.step = step;
        item.progress = progress;
      }
    },
    removeFromQueue: (state, action) => {
      return state.filter((item) => item.queryID !== action.payload.queryID);
    },
    resetQueue: () => {
      return [];
    },
  },
});

export const { addToQueue, markAsStarted, updateProgress, removeFromQueue, resetQueue } = queueSlice.actions;
export default queueSlice.reducer;
